export default __webpack_public_path__ + "static/toggl-track-main-86a903eba7e603cda581878765469d51.jpg";